//imports
import {
    DEVICES_OVERVIEW_GET_DATA_REQUEST,
    DEVICES_OVERVIEW_GET_DATA_RESULT,
    DEVICES_OVERVIEW_REFRESH_FIRMWARES,
    DEVICES_OVERVIEW_REFRESH_FIRMWARES_RESULT,
    DEVICES_OVERVIEW_GET_CTC_INFO_REQUEST,
    DEVICES_OVERVIEW_GET_CTC_INFO_RESULT
} from 'Redux/actionTypes';

export const devicegetDataRequest = (id) => ({
    type: DEVICES_OVERVIEW_GET_DATA_REQUEST,
    payload: {id},
});

export const devicegetDataResult = (result) => ({
    type: DEVICES_OVERVIEW_GET_DATA_RESULT,
    payload: result
});

export const deviceFirmwaresRefreshRequest = () => ({
    type: DEVICES_OVERVIEW_REFRESH_FIRMWARES,
    payload: {},
});

export const deviceFirmwaresRefreshRequestResult = (result) => ({
    type: DEVICES_OVERVIEW_REFRESH_FIRMWARES_RESULT,
    payload: result
});

export const deviceGetCtcInfoRequest = (esn) => ({
    type: DEVICES_OVERVIEW_GET_CTC_INFO_REQUEST,
    payload: {esn},
});

export const deviceGetCtcInfoResult = (result) => ({
    type: DEVICES_OVERVIEW_GET_CTC_INFO_RESULT,
    payload: result
});